import {
  Component,
  input,
  OnInit,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { InputType } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-create-schedule',
  templateUrl: './modal-create-schedule.component.html',
  styleUrl: './modal-create-schedule.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalCreateScheduleComponent implements OnInit {
  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly edit = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly clientId = input<number | undefined>();
  readonly days = input<any>();
  readonly action = output<any>();

  public images = images;

  public timeObject = {
    height: 40,
    fontSize: 16,
    value: '',
    edit: {
      inputType: InputType.TIME,
    },
  };

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json',
  };

  public applyIntervals = true;

  public dayOfWeekToCreate = {
    driver: {},
    vehicle: {},
    days: [] as any,
    startTime: '',
    endTime: '',
    interval: '',
    intervalDuration: '',
    message: '',
  };

  public formGroup: FormGroup = new FormGroup({});

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  ngOnInit(): void {
    this.setControls();
  }

  setControls() {
    this.formGroup.addControl(
      'driver',
      new FormControl('', [Validators.required]),
    );
    this.formGroup.addControl(
      'vehicle',
      new FormControl('', [Validators.required]),
    );
    this.formGroup.addControl(
      'days',
      new FormControl([], [this.arrayRequired]),
    );
    this.formGroup.addControl(
      'startTime',
      new FormControl('', [Validators.required]),
    );
    this.formGroup.addControl(
      'endTime',
      new FormControl('', [Validators.required]),
    );
    if (this.applyIntervals) {
      this.formGroup.addControl(
        'interval',
        new FormControl('', [Validators.required]),
      );
    }
  }

  getTimeObject(type: 'startTime' | 'endTime') {
    const timeObject = { ...this.timeObject };
    timeObject.value = this.dayOfWeekToCreate[type];
    return timeObject;
  }

  arrayRequired(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    return Array.isArray(value) && value.length > 0 ? null : { required: true };
  }

  updateSelection(
    selected: { value: any; label: string },
    type: 'driver' | 'vehicle',
  ) {
    const option = {
      id: selected.value,
      value: selected.value,
      label: selected.label,
    };
    this.dayOfWeekToCreate[type] = option;
    this.formGroup.get(type)?.setValue(option);
  }

  updateData(
    data: any,
    type:
      | 'driver'
      | 'vehicle'
      | 'days'
      | 'startTime'
      | 'endTime'
      | 'interval'
      | 'intervalDuration'
      | 'message',
  ) {
    if (type === 'days') {
      this.formGroup.get(type)?.setValue(this.dayOfWeekToCreate[type]);
    } else if (data.options) {
      this.dayOfWeekToCreate[type] = data.options[0];
      this.formGroup.get(type)?.setValue(data.options[0]);
    } else {
      this.dayOfWeekToCreate[type] = data.target.value;
      this.formGroup.get(type)?.setValue(data.target.value);
    }
  }

  changeInterval(status: boolean) {
    this.applyIntervals = status;
    if (status) {
      this.formGroup.addControl(
        'interval',
        new FormControl('', [Validators.required]),
      );
    } else {
      this.formGroup.get('interval')?.setValue('');
      this.formGroup.get('intervalDuration')?.setValue('');
      this.dayOfWeekToCreate['interval'] = '';
      this.dayOfWeekToCreate['intervalDuration'] = '';
      this.formGroup.removeControl('interval');
    }
  }

  onSubmit() {
    this.action.emit(this.dayOfWeekToCreate);
  }
}
